"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnlockEvent = exports.LockEvent = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
exports.protobufPackage = "Switcheo.carbon.lockproxy";
const baseLockEvent = {
    denom: "",
    fromLockProxy: "",
    fromAssetId: "",
    fromAddress: "",
    toChainId: "",
    toLockProxy: "",
    toAssetId: "",
    toAddress: "",
    amount: "",
    feeAmount: "",
    feeAddress: "",
    nonce: "",
};
exports.LockEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.fromLockProxy !== "") {
            writer.uint32(18).string(message.fromLockProxy);
        }
        if (message.fromAssetId !== "") {
            writer.uint32(26).string(message.fromAssetId);
        }
        if (message.fromAddress !== "") {
            writer.uint32(34).string(message.fromAddress);
        }
        if (message.toChainId !== "") {
            writer.uint32(42).string(message.toChainId);
        }
        if (message.toLockProxy !== "") {
            writer.uint32(50).string(message.toLockProxy);
        }
        if (message.toAssetId !== "") {
            writer.uint32(58).string(message.toAssetId);
        }
        if (message.toAddress !== "") {
            writer.uint32(66).string(message.toAddress);
        }
        if (message.amount !== "") {
            writer.uint32(74).string(message.amount);
        }
        if (message.feeAmount !== "") {
            writer.uint32(82).string(message.feeAmount);
        }
        if (message.feeAddress !== "") {
            writer.uint32(90).string(message.feeAddress);
        }
        if (message.nonce !== "") {
            writer.uint32(98).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseLockEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.fromLockProxy = reader.string();
                    break;
                case 3:
                    message.fromAssetId = reader.string();
                    break;
                case 4:
                    message.fromAddress = reader.string();
                    break;
                case 5:
                    message.toChainId = reader.string();
                    break;
                case 6:
                    message.toLockProxy = reader.string();
                    break;
                case 7:
                    message.toAssetId = reader.string();
                    break;
                case 8:
                    message.toAddress = reader.string();
                    break;
                case 9:
                    message.amount = reader.string();
                    break;
                case 10:
                    message.feeAmount = reader.string();
                    break;
                case 11:
                    message.feeAddress = reader.string();
                    break;
                case 12:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseLockEvent);
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.fromLockProxy =
            object.fromLockProxy !== undefined && object.fromLockProxy !== null
                ? String(object.fromLockProxy)
                : "";
        message.fromAssetId =
            object.fromAssetId !== undefined && object.fromAssetId !== null
                ? String(object.fromAssetId)
                : "";
        message.fromAddress =
            object.fromAddress !== undefined && object.fromAddress !== null
                ? String(object.fromAddress)
                : "";
        message.toChainId =
            object.toChainId !== undefined && object.toChainId !== null
                ? String(object.toChainId)
                : "";
        message.toLockProxy =
            object.toLockProxy !== undefined && object.toLockProxy !== null
                ? String(object.toLockProxy)
                : "";
        message.toAssetId =
            object.toAssetId !== undefined && object.toAssetId !== null
                ? String(object.toAssetId)
                : "";
        message.toAddress =
            object.toAddress !== undefined && object.toAddress !== null
                ? String(object.toAddress)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.feeAmount =
            object.feeAmount !== undefined && object.feeAmount !== null
                ? String(object.feeAmount)
                : "";
        message.feeAddress =
            object.feeAddress !== undefined && object.feeAddress !== null
                ? String(object.feeAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? String(object.nonce)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.fromLockProxy !== undefined &&
            (obj.fromLockProxy = message.fromLockProxy);
        message.fromAssetId !== undefined &&
            (obj.fromAssetId = message.fromAssetId);
        message.fromAddress !== undefined &&
            (obj.fromAddress = message.fromAddress);
        message.toChainId !== undefined && (obj.toChainId = message.toChainId);
        message.toLockProxy !== undefined &&
            (obj.toLockProxy = message.toLockProxy);
        message.toAssetId !== undefined && (obj.toAssetId = message.toAssetId);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.amount !== undefined && (obj.amount = message.amount);
        message.feeAmount !== undefined && (obj.feeAmount = message.feeAmount);
        message.feeAddress !== undefined && (obj.feeAddress = message.feeAddress);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const message = Object.assign({}, baseLockEvent);
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.fromLockProxy = (_b = object.fromLockProxy) !== null && _b !== void 0 ? _b : "";
        message.fromAssetId = (_c = object.fromAssetId) !== null && _c !== void 0 ? _c : "";
        message.fromAddress = (_d = object.fromAddress) !== null && _d !== void 0 ? _d : "";
        message.toChainId = (_e = object.toChainId) !== null && _e !== void 0 ? _e : "";
        message.toLockProxy = (_f = object.toLockProxy) !== null && _f !== void 0 ? _f : "";
        message.toAssetId = (_g = object.toAssetId) !== null && _g !== void 0 ? _g : "";
        message.toAddress = (_h = object.toAddress) !== null && _h !== void 0 ? _h : "";
        message.amount = (_j = object.amount) !== null && _j !== void 0 ? _j : "";
        message.feeAmount = (_k = object.feeAmount) !== null && _k !== void 0 ? _k : "";
        message.feeAddress = (_l = object.feeAddress) !== null && _l !== void 0 ? _l : "";
        message.nonce = (_m = object.nonce) !== null && _m !== void 0 ? _m : "";
        return message;
    },
};
const baseUnlockEvent = {
    toAssetId: "",
    toAddress: "",
    amount: "",
    fromAddress: "",
    fromAssetId: "",
    feeAmount: "",
    feeAddress: "",
    nonce: "",
};
exports.UnlockEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.toAssetId !== "") {
            writer.uint32(10).string(message.toAssetId);
        }
        if (message.toAddress !== "") {
            writer.uint32(18).string(message.toAddress);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.fromAddress !== "") {
            writer.uint32(34).string(message.fromAddress);
        }
        if (message.fromAssetId !== "") {
            writer.uint32(42).string(message.fromAssetId);
        }
        if (message.feeAmount !== "") {
            writer.uint32(50).string(message.feeAmount);
        }
        if (message.feeAddress !== "") {
            writer.uint32(58).string(message.feeAddress);
        }
        if (message.nonce !== "") {
            writer.uint32(66).string(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUnlockEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.toAssetId = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.fromAddress = reader.string();
                    break;
                case 5:
                    message.fromAssetId = reader.string();
                    break;
                case 6:
                    message.feeAmount = reader.string();
                    break;
                case 7:
                    message.feeAddress = reader.string();
                    break;
                case 8:
                    message.nonce = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUnlockEvent);
        message.toAssetId =
            object.toAssetId !== undefined && object.toAssetId !== null
                ? String(object.toAssetId)
                : "";
        message.toAddress =
            object.toAddress !== undefined && object.toAddress !== null
                ? String(object.toAddress)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.fromAddress =
            object.fromAddress !== undefined && object.fromAddress !== null
                ? String(object.fromAddress)
                : "";
        message.fromAssetId =
            object.fromAssetId !== undefined && object.fromAssetId !== null
                ? String(object.fromAssetId)
                : "";
        message.feeAmount =
            object.feeAmount !== undefined && object.feeAmount !== null
                ? String(object.feeAmount)
                : "";
        message.feeAddress =
            object.feeAddress !== undefined && object.feeAddress !== null
                ? String(object.feeAddress)
                : "";
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? String(object.nonce)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.toAssetId !== undefined && (obj.toAssetId = message.toAssetId);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.amount !== undefined && (obj.amount = message.amount);
        message.fromAddress !== undefined &&
            (obj.fromAddress = message.fromAddress);
        message.fromAssetId !== undefined &&
            (obj.fromAssetId = message.fromAssetId);
        message.feeAmount !== undefined && (obj.feeAmount = message.feeAmount);
        message.feeAddress !== undefined && (obj.feeAddress = message.feeAddress);
        message.nonce !== undefined && (obj.nonce = message.nonce);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const message = Object.assign({}, baseUnlockEvent);
        message.toAssetId = (_a = object.toAssetId) !== null && _a !== void 0 ? _a : "";
        message.toAddress = (_b = object.toAddress) !== null && _b !== void 0 ? _b : "";
        message.amount = (_c = object.amount) !== null && _c !== void 0 ? _c : "";
        message.fromAddress = (_d = object.fromAddress) !== null && _d !== void 0 ? _d : "";
        message.fromAssetId = (_e = object.fromAssetId) !== null && _e !== void 0 ? _e : "";
        message.feeAmount = (_f = object.feeAmount) !== null && _f !== void 0 ? _f : "";
        message.feeAddress = (_g = object.feeAddress) !== null && _g !== void 0 ? _g : "";
        message.nonce = (_h = object.nonce) !== null && _h !== void 0 ? _h : "";
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
